import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { LinkProps } from 'react-router-dom'

import { Link } from '@lib/react-router-dom'

import { Body2 } from '@ui/Typography'

import { useWindowResize } from '@utils/domUtils'
import { getPortalRoot } from '@utils/portals'

import { BubbleProps } from '../Bubble/Bubble'
import { InfoCardMobile } from './InfoCard'

import styles from './InfoCardReadMore.module.scss'

export interface InfoCardProps extends BubbleProps {
  title?: string
  text?: React.ReactNode
  render?: React.ReactNode
  link?: InfoCardLinkProps
  lockDirection?: boolean

  className?: string
  modalCardClassName?: string

  /** @deprecated rarely used, for hacky workarounds  */
  cardStyle?: React.CSSProperties
}

export interface InfoCardLinkProps {
  to: LinkProps['to']
  state?: LinkProps['state']
  text: string
  target?: LinkProps['target']
}

/** @deprecated rarely used, need fix InfoCard, should use portal */
export const InfoCardReadMore: React.FC<InfoCardProps> = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <InfoCardMobile {...props} /> : <InfoCardDesktop {...props} />
}

const InfoCardDesktop: React.FC<InfoCardProps> = (props) => {
  return <InfoCardDesktopWithCardStyle {...props} />
}

/** @deprecated rarely used, need fix InfoCard, should use portal */
export const InfoCardDesktopWithCardStyle: React.FC<InfoCardProps> = (props) => {
  const { direction = 'bottom', children } = props

  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const isMobile = useWindowResize()
  const containerRef = useRef<HTMLDivElement>(null)
  const [position, setPosition] = useState({ x: 0, y: 0 })

  const openPopupOnHover = () => {
    if (!isMobile) {
      setIsPopupOpen(true)
    }
  }

  const closePopupOnHover = () => {
    if (!isMobile) {
      setIsPopupOpen(false)
    }
  }

  const updatePosition = () => {
    if (!containerRef.current) {
      return
    }
    const { left, top, height } = containerRef.current.getBoundingClientRect()

    if (direction === 'bottom') {
      setPosition({
        x: left + window.scrollX,
        y: top + window.scrollY + height,
      })
    } else {
      setPosition({
        x: left + window.scrollX,
        y: top + window.scrollY,
      })
    }
  }

  useEffect(() => {
    if (isPopupOpen) {
      updatePosition()
    }
  }, [isPopupOpen])

  return (
    <div ref={containerRef} onMouseEnter={openPopupOnHover} onMouseLeave={closePopupOnHover}>
      {isPopupOpen && (
        <InfoCardTooltip {...props} cardStyle={{ top: position.y, left: position.x }} />
      )}
      {children}
    </div>
  )
}

const InfoCardTooltip: React.FC<InfoCardProps> = (props) => {
  const { cardStyle, text, link, direction } = props

  const tooltipRoot = getPortalRoot('TOOLTIP')
  return createPortal(
    <div
      className={classNames(styles.infoContent, {
        [styles.top]: direction === 'top',
      })}
      style={cardStyle}
    >
      <Body2 isParagraph>{text}</Body2>
      {link && (
        <Body2>
          <Link to={link.to} target={link.target} state={link.state}>
            {link.text}
          </Link>
        </Body2>
      )}
    </div>,
    tooltipRoot
  )
}
